import React from 'react';

export const OutsourceFlag = () => <i className="fa fa-external-link-square-alt text-secondary mr-3" title="Invoice Batch marked as Outsourced" />;
